module.exports = __webpack_public_path__ + "assets/img/back_003.bd16f962.png";